<template>
  <v-row>
    <v-col class="xs" cols="12">
      <v-card flat>
        <div v-if="!onEdit" class="mb-3 mt-n1 text--secondary">Here you can keep important documents like your working contract, other company agreements, certifications and scans of id’s etc.</div>
        <div v-else class="mb-3 mt-n1 text--secondary">Keep important documents safe and easily accessible, e.g. working contract, other relevant personal agreements, certifications and scans of id’s etc.</div>
        <v-card-actions class="mb-n6">
          <v-spacer />
          <v-btn
            small
            depressed
            fab
            class="action white--text mr-3"
            @click="dialog = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Format</th>
                  <th class="text-left">External link</th>
                  <th class="text-left">Uploaded doc</th>
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in documents" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td class="text-left">{{ item.type }}</td>
                  <td>{{ item.format }}</td>
                  <td class="text-left">
                    <a :href="item.url" v-if="item.url" target="_blank">link</a>
                    <span v-else>-</span>
                  </td>
                  <td class="text-left">
                    <div v-if="item.storage_ref">
                      <v-btn icon @click="openFile(item.storage_ref)">
                        <v-icon>get_app</v-icon>
                      </v-btn>
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td class="text-left">
                    <v-icon @click="edit(item.id)">edit</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!--	Add/Edit dialog -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card flat>
        <v-card-title class="py-2 theme">
          <span class="title white--text">Add document or file</span>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-form ref="documentForm">
              <v-row>
                <div class="grey--text text--darken-1 mt-5">
                  Add relevant employee documents such as employment contracts
                  or option programs etc.
                </div>
        
                <v-col cols="12">
                  <v-text-field
                    class="my-3"
                    label="Document name"
                    placeholder="Example: Employee contract"
                    v-model="name"
                    :rules="[validationRules.required]"
                  />

                  <v-autocomplete
                    :items="types"
                    class="my-3"
                    label="Type"
                    v-model="type"
                    :rules="[validationRules.required]"
                    placeholder="Example: Handbook"
                  />

                  <v-autocomplete
                    class="my-3"
                    :items="formats"
                    placeholder="Example: pdf"
                    label="Format of document"
                    v-model="format"
                    :rules="[validationRules.required]"
                  />

                  <v-textarea
                    class="my-3"
                    label="Document description"
                    v-model="description"
                  ></v-textarea>

                  <v-text-field
                    class="my-3"
                    label="Provide a URL"
                    hint="If document is external, provide a link to access the document"
                    persistent-hint
                    v-model="url"
                  />

                  <v-file-input
                    class="mb-3"
                    v-model="fileInput"
                    show-size
                    label="Or upload a new document"
                    hint="Upload a new document"
                    persistent-hint
                    prepend-icon=""
                    clearable
                  ></v-file-input>
                  <small class="grey--text">*indicates required field</small>
                </v-col>

                <!-- <v-flex xs12 lg5 /> -->
              </v-row>
              <v-btn
                depressed
                class="save white--text ml-0 mt-5"
                text
                @click="saveDocument"
                >Save</v-btn
              >
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--    <v-dialog v-model="dialogPDF" persistent max-width="600px">-->
    <!--      <v-card flat>-->
    <!--        <v-card-title class="py-2 theme">-->
    <!--          <span class="title white&#45;&#45;text">View Document</span>-->
    <!--          <v-spacer/>-->
    <!--          <v-btn icon @click="dialogPDF = false">-->
    <!--            <v-icon class="white&#45;&#45;text">close</v-icon>-->
    <!--          </v-btn>-->
    <!--        </v-card-title>-->
    <!--        <v-divider/>-->
    <!--        <v-card-text>-->
    <!--          <v-container>-->
    <!--            <v-row>-->

    <!--              <v-col cols="12">-->
    <!--                <pdf-->
    <!--                    :src="pdfURL"></pdf>-->
    <!--                    @num-pages="pageCount = $event"-->
    <!--                    @page-loaded="currentPage = $event"-->
    <!--                ></pdf>-->
    <!--              </v-col>-->
    <!---->
    <!--               <v-flex xs12 lg5 /> -->
    <!--            </v-row>-->
    <!--          </v-container>-->
    <!--        </v-card-text>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->

    <!--	Snackbar	-->
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import firebase from "firebase/app";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
// import pdf          from 'vue-pdf';

export default {
  name: Component.Protected.Employee.Document,
  props: ['onEdit'],
  computed: {
    ...mapGetters(["userInfo", "countries"]),
  },
  // components: {pdf},
  data: () => ({
    pdfURL: "",
    fileInput: null,
    documents: [],
    formats: Constants.Document.Format.All,
    types: Constants.Document.Type.All,
    id: null,
    dialog: false,
    type: null,
    name: null,
    description: null,
    url: null,
    format: null,
    documentID: null,
    uid: "",
    dialogPDF: false,
  }),
  methods: {
    openFile(path) {
      firebase
        .storage()
        .ref(path)
        .getDownloadURL()
        .then((r) => {
          window.open(r, "_blank");
          // this.pdfURL = r;
          // this.dialogPDF = true;
          // //var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
          // let xhr = new XMLHttpRequest();
          // xhr.responseType = 'blob';
          // xhr.onload = function() {
          //   let a = document.createElement('a');
          //   a.href = window.URL.createObjectURL(xhr.response);
          //   a.download = "fileDownloaded.filetype"; // Name the file anything you'd like.
          //   a.style.display = 'none';
          //   document.body.appendChild(a);
          //   a.click();
          // };
          // xhr.open('GET', r);
          // xhr.send();
        });
    },
    reset() {
      this.dialog = false;
      this.documents = [];
      this.resetModels();
    },
    resetModels() {
      this.type = null;
      this.name = null;
      this.description = null;
      this.url = null;
      this.format = null;
      this.documentID = null;
    },
    saveDocument() {
      if (this.$refs.documentForm.validate()) {
        let payload = {
          data: {
            type: this.type,
            name: this.name,
            description: this.description,
            company_id: parseInt(this.userInfo.companyID),
            user_id: parseInt(this.id),
            url: this.url,
            format: this.format,
          },
        };

        if (this.fileInput) {
          const fileName = `company/${this.userInfo.namespace}/${this.uid}/documents/${this.fileInput.name}`;
          payload.data.storage_ref = fileName;
          const data = {
            fileName: fileName,
            metadata: {
              customMetadata: {
                namespace: this.userInfo.namespace,
                uid: this.uid,
                type: "document",
              },
            },
            content: this.fileInput,
          };

          this.$store
            .dispatch(Actions.Firebase.UploadPrivateDocuments, data)
            .catch((err) => {
              console.error(Constants.Document.Messages.Error.Edit, err);
              this.snackbarMessage = Constants.Document.Messages.Error.Edit;
              this.snackbar = true;
            });
        }

        if (this.documentID) {
          payload.documentID = this.documentID;
        }
        this.dialog = false;
        this.$store
          .dispatch(Actions.Document.Save, payload)
          .then(() => {
            this.getAll();
          })
          .catch((err) => {
            console.error(Constants.Document.Messages.Error.Edit, err);
            this.snackbarMessage = Constants.Document.Messages.Error.Edit;
            this.snackbar = true;
          });
      }
    },
    getAll() {
      this.reset();
      this.getUser();
      this.$store
        .dispatch(Actions.Document.All, this.id)
        .then((r) => {
          if (r.status === 200 && r.data) {
            this.documents = r.data;
          }
        })
        .catch((err) => {
          console.error(Constants.Document.Messages.Error.Find, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Document.Messages.Error.Find;
        });
    },
    getDocument(id) {
      this.$store
        .dispatch(Actions.Document.Get, id)
        .then((r) => {
          if (r.status === 200 && r.data) {
            this.name = r.data.name;
            this.type = r.data.type;
            this.description = r.data.description;
            this.url = r.data.url;
            this.format = r.data.format;
            this.documentID = r.data.id;
          }
        })
        .catch((err) => {
          console.error(Constants.Document.Messages.Error.Get, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Document.Messages.Error.Get;
        });
    },

    getUser() {
      this.$store.dispatch(Actions.Employee.Get, this.id).then((r) => {
        if (r.status === 200) {
          this.uid = r.data.uid;
          console.log(this.uid);
        }
      });
    },
    edit(id) {
      this.getDocument(id);
      this.dialog = true;
    },
  },
  created() {
    // this component is accessed from different paths,
    // so we need to initialize this.id differently
    if (this.userInfo) {
      if (this.$route.params.id) {
        this.id = `${this.$route.params.id}`;
        this.getAll();
      } else if (this.$route.fullPath === "/me") {
        this.id = this.userInfo.userID;
        this.getAll();
      }
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.getAll());
    }
    // todo:
    // 1. add button for send email invitation
    // 2. send services
    // 3. check the modals for welcome employee
    // 4. add documents to my info
  },
};
</script>
